import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { RequestLogResponse } from '../../responses/srv-message-queue/request-log.response';

@Injectable({
  providedIn: 'root'
})
export class RequestLogService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public search(datetimeInitRequest?: Date, pageIndex?: number, searchText?: string, messageType?: string, idHealthUnit?: number): Observable<RequestLogResponse> {
    let uri = `RequestLog/GetAll?`

    if (pageIndex != null)
      uri = uri + `pageIndex=${pageIndex}&`;
    if (datetimeInitRequest != null)
      uri = uri + `datetimeInitRequest=${encodeURIComponent(datetimeInitRequest.toISOString())}&`;
    if (searchText != null)
      uri = uri + `searchText=${searchText}&`;
    if (messageType != null)
      uri = uri + `idMessageType=${messageType}&`;
    if (idHealthUnit != null)
      uri = uri + `idHealthUnit=${idHealthUnit}&`;

    return this.httpClient.get<RequestLogResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSRVMessageQueue) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
